import React from 'react';

import {THead} from '../Markdown';
import {withMDXBoundary} from '../MDXErrorBoundary';
import {Figure, FigureLegend, LessonPre} from './Figure';
import Callout, {CalloutBox} from '../Callout';
import {CodeDownload} from './CodeDownload';
import {Collapsible} from './Collapsible';
import {LessonCard, Badge} from './LessonCard';
import Pill from './Pill';
import {textContent} from './util';

const wrap = (Component, name) => withMDXBoundary(Component, name);

// Headerless tables: markdown always requires a header row, so a row of empty
// cells (`| | |`) renders as an empty gray strip. Drop the <thead> entirely
// when every header cell is empty.
const LessonTHead = ({children, ...props}) => (
  textContent(children).trim()
    ? <THead {...props}>{children}</THead>
    : null
);

/**
 * Component registry for lesson MDX, layered on top of the base registry in
 * components/MDX.js. Every entry is wrapped in an error boundary: a component
 * that throws renders nothing (and reports to Sentry) instead of breaking the
 * lesson. See docs/lesson-markdown-components.md for authoring usage.
 */
export const lessonComponents = {
  Badge: wrap(Badge, 'Badge'),
  Callout: wrap(Callout, 'Callout'),
  CalloutBox: wrap(CalloutBox, 'CalloutBox'),
  CodeDownload: wrap(CodeDownload, 'CodeDownload'),
  Collapsible: wrap(Collapsible, 'Collapsible'),
  Figure: wrap(Figure, 'Figure'),
  FigureLegend: wrap(FigureLegend, 'FigureLegend'),
  LessonCard: wrap(LessonCard, 'LessonCard'),
  Pill: wrap(Pill, 'Pill'),
  // Route ```mermaid fences to the Mermaid renderer.
  pre: LessonPre,
  // Drop empty header rows so `| | |` produces a headerless table.
  thead: LessonTHead,
};

export default lessonComponents;
